<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu :default-active="activeMenu" :collapse="isCollapse" :background-color="variables.menuBg"
        :text-color="variables.menuText" :unique-opened="false" :active-text-color="variables.menuActiveText"
        :collapse-transition="false" mode="vertical">
        <sidebar-item v-for="route in routers" :key="route.name" :item="route" :base-path="route.path"
          :notice="systemNotice" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import request from "@/utils/request";
import variables from "@/styles/variables.scss";

export default {
  data: () => ({
    systemNotice: {}
  }),
  components: {
    SidebarItem,
    Logo
  },
  methods: {
    async getSystemNotification() {
      try {
        const { data } = await request({
          url: "/api/backend/system/notice",
          method: "GET"
        })
        console.log(data);
        this.systemNotice = data
      } catch (err) {
        throw err
      }
    }
  },
  computed: {
    ...mapGetters(["sidebar", "routers"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  mounted() {
    this.getSystemNotification()

    let timeInterval = setInterval(async () => {
      try {
        await this.getSystemNotification()
      } catch {
        clearInterval(timeInterval)
        this.$notify.error({
          title: '错误',
          message: '获取系统通知失败'
        });
      }
    }, 10000);
  },
  beforeDestroy() {
    clearInterval()
  }
};
</script>
